import {
  ObservationsV1IssueCloseExplanationReason as ExplanationReason,
  ObservationsV1IssueCloseReason,
  ObservationsV1IssueState,
} from '@spotify/confidence-graphql';
import { IssueFragment } from '@spotify/plugin-confidence-issues-react';

type ClosureReasonOption = {
  label: string;
  closeReason?: ObservationsV1IssueCloseReason;
};
type ClosureReasonOptions = Record<ExplanationReason, ClosureReasonOption>;

const CLOSURE_REASON_OPTIONS: ClosureReasonOptions = {
  [ExplanationReason.LowImpact]: {
    label: 'Low impact',
    closeReason: ObservationsV1IssueCloseReason.WontFix,
  },
  [ExplanationReason.NotAPriority]: {
    label: 'Not a priority',
    closeReason: ObservationsV1IssueCloseReason.WontFix,
  },
  [ExplanationReason.TooCostlyToFix]: {
    label: 'Too costly to fix',
    closeReason: ObservationsV1IssueCloseReason.WontFix,
  },
  [ExplanationReason.AlternativeAvailable]: {
    label: 'Alternative available',
    closeReason: ObservationsV1IssueCloseReason.WontFix,
  },
  [ExplanationReason.ExpectedBehavior]: {
    label: 'Expected behavior',
    closeReason: ObservationsV1IssueCloseReason.NonIssue,
  },
  [ExplanationReason.Duplicate]: {
    label: 'Duplicate',
    closeReason: ObservationsV1IssueCloseReason.NonIssue,
  },
  [ExplanationReason.CannotReproduce]: {
    label: 'Cannot reproduce',
    closeReason: ObservationsV1IssueCloseReason.NonIssue,
  },
  [ExplanationReason.InsufficientEvidence]: {
    label: 'Insufficient evidence',
    closeReason: ObservationsV1IssueCloseReason.NonIssue,
  },
  [ExplanationReason.Other]: { label: 'Other' },
};

export const getClosureReasonOptions = (
  closeReason: ObservationsV1IssueCloseReason,
): Record<string, ClosureReasonOption> =>
  Object.fromEntries(
    Object.entries(CLOSURE_REASON_OPTIONS).filter(
      ([, option]) => !option.closeReason || option.closeReason === closeReason,
    ),
  );

export const getClosureExplanation = (
  issue: IssueFragment,
): string | undefined => {
  if (
    issue.state !== ObservationsV1IssueState.Closed ||
    !issue.closeExplanation
  )
    return undefined;
  const reasonLabel = issue.closeExplanation.reason
    ? CLOSURE_REASON_OPTIONS[issue.closeExplanation.reason]?.label
    : undefined;
  return (
    [reasonLabel, issue.closeExplanation.details].filter(Boolean).join(': ') ||
    undefined
  );
};
